import { render, staticRenderFns } from "./DnsBatchList.vue?vue&type=template&id=068067ab&scoped=true"
import script from "./DnsBatchList.vue?vue&type=script&lang=js"
export * from "./DnsBatchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068067ab",
  null
  
)

export default component.exports